import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

const useActiveTab = (tabName: string) => {
  const [activeTab, setActiveTab] = useState<string>(tabName);
  const router = useRouter();

  useEffect(() => {
    let newActiveTab = '';
    if (router?.asPath?.includes('practice-marketing')) {
      newActiveTab = 'Practice Marketing Resources';
    } else {
      newActiveTab = tabName;
    }
    setActiveTab(newActiveTab);
  }, [router.asPath, tabName]);

  return { activeTab };
};

export default useActiveTab;
